<template>
  <v-app>
    <template v-if="isAuthenticated">
      <router-view />
    </template>
    <template v-else-if="processingAuthentication">
      <div class="d-flex align-center justify-center" style="height: 30vh;">
        <v-progress-circular
          color="primary"
          indeterminate
          class="mr-3"
        ></v-progress-circular>
        Login wird geprüft...
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-center justify-center" style="height: 30vh;">
        <v-icon class="mdi mdi-account-cancel mr-4" size="x-large"></v-icon>
        Ihr Login konnte nicht verifiziert werden.<br />
        Bitte laden Sie die Seite neu.
      </div>
    </template>
  </v-app>
</template>

<script lang="ts" setup>
import AuthService      from "@/api/AuthService"
import { useStorage }   from "vue3-storage"
import { useUserStore } from "@/stores/userStore"

const userStore = useUserStore()

onMounted(async () => {
  document.title = import.meta.env.VITE_APP_TITLE

  await checkAuth()
})

const processingAuthentication = ref(false)
const isAuthenticated = ref(false)

const checkAuth = async () => {
  processingAuthentication.value = true

  // try to get one-time-token from uri-params
  const search = window.location.search.substring(1)
  const params = new URLSearchParams(search)


  const storage = useStorage()

  if (params && params.has("usrId") && params.has("ott")) {
    const usrId = parseInt(params.get("usrId") || "")
    const oneTimeToken = params.get("ott")

    if (oneTimeToken) {
      const authService = new AuthService()
      await authService.getUserToken(usrId, oneTimeToken).then(data => {
        if (data.success && data.data) {
          storage.setStorageSync("token", data.data.token)
          isAuthenticated.value = true
          processingAuthentication.value = false

          window.setTimeout(function () {
            const newUrl = new URL(window.location.href)
            newUrl.search = newUrl.search.replace(/ott=.*?$/i, "").replace(/usrId=.*?$/i, "")
            window.history.replaceState({}, document.title, newUrl.toString())
          }, 2000)

          window.setInterval(function () {
            authService.checkLogin().then(data => {
              if (!data || !data.success || !data.data.success) {
                storage.removeStorageSync("token")
                isAuthenticated.value = false
              }
            })
          }, 30000)
        } else {
          storage.removeStorageSync("token")
          isAuthenticated.value = false
        }
      })
    }
  } else if (storage.getStorageSync("token")) {
    isAuthenticated.value = true
    processingAuthentication.value = false
  } else {
    isAuthenticated.value = false
    processingAuthentication.value = false
  }

  if (isAuthenticated.value) {
    await userStore.loadUserConfig("extended-filter", "task-item-package")
    await userStore.loadWorkProject()
    await userStore.loadUserInfo()
  }
}
</script>
